module.exports = __webpack_public_path__ + "img/desktop-header_seo-v2.840692c.webp";